import { useLoaderData, useNavigate, useSearch } from '@tanstack/react-router';
import { ASSET_ROUTE_URL } from '../../../constants/routes';
import { useOrderbookRowClick } from '../../../hooks/useOrderbookRowClick';
import { useOrderbookRowCount } from '../../../hooks/useOrderbookRowCount';
import { useTailwindBreakpoint } from '../../../hooks/useTailwindBreakpoint';
import { cn } from '../../../lib/classNameHelpers';
import { Card } from '../../Card';
import { InlineSelect } from '../../InlineSelect/InlineSelect';
import { SideBySideOrderbookUi } from '../../Orderbook/layouts/SideBySideOrderbook';
import { StandardOrderbookUi } from '../../Orderbook/layouts/StandardOrderbook';
import { Orderbook } from '../../Orderbook/Orderbook';
import { Trades } from '../Trades';

const ORDERBOOK_TABS = [
  { value: 'orderbook', label: 'Order Book' },
  { value: 'trades', label: 'Trades' },
] as const;

export function TradeOrderbookTabs({ className }: { className?: string }) {
  const { orderbookTab } = useSearch({ from: ASSET_ROUTE_URL });
  const navigate = useNavigate({ from: ASSET_ROUTE_URL });
  const { product } = useLoaderData({ from: ASSET_ROUTE_URL });
  const isLg = useTailwindBreakpoint('lg');

  const handleOrderbookRowClick = useOrderbookRowClick();
  const orderbookRowCount = useOrderbookRowCount();

  return (
    <Card className={cn('flex w-full shrink-0 flex-col lg:w-[260px]', className)}>
      <InlineSelect
        className="gap-0 border-borderPrimary lg:border-b"
        buttonClassName="!p-4"
        options={ORDERBOOK_TABS}
        onChange={(option) =>
          option && navigate({ search: (prev) => ({ ...prev, orderbookTab: option.value }) })
        }
        selected={orderbookTab}
      />
      {orderbookTab === 'orderbook' && (
        <Orderbook
          product={product}
          layout={isLg ? StandardOrderbookUi : SideBySideOrderbookUi}
          rowCount={orderbookRowCount}
          onRowClick={handleOrderbookRowClick}
        />
      )}
      {orderbookTab === 'trades' && <Trades product={product} />}
    </Card>
  );
}
